import React            from 'react';

class Wrapper extends React.Component {
    constructor(props) {
        super(props);
        this.state = { };
    }

    createComponentClasses() {
        let {
            isFocused,
            isDisabled,
            className,
        } = this.props;

        let classNames = ['simprakit-textarea-wrapper'];
        if (isDisabled)                                classNames.push('disabled');
        if (isFocused)                                 classNames.push('focused');
        if (className)                                 Array.prototype.push.apply(classNames, className.split(' '));

        return [...new Set(classNames)].join(' ');
    }

    render(){
        return(
            <div className={ this.createComponentClasses() }>
                { this.props.children }
            </div>
        )
    }
}

export default Wrapper;